import z from "zod";
import { ConnectorType } from "../connector";
// Базовая схема для ChargingStationModel (общие поля)
export const zChargingStationModelCommonSchema = z.object({
    id: z.string(),
    idManufacturer: z.string(),
    name: z.string(),
    powerKw: z.number(),
    portCount: z.number(),
    supportedConnectors: z.array(z.enum(ConnectorType)).nullable(),
    maxCurrentA: z.number(),
    inputVoltage: z.number(),
    outputVoltage: z.array(z.number()).nullable(),
    weight: z.number().nullish(),
    dimensions: z.string().nullish(),
    features: z.any().optional(), // jsonb
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
    maxChargeCapacity: z.number().nullish(),
});
export const zChargingStationModelFiltersSchema = z.object({
    search: z.string().optional(),
});
